module.exports = __webpack_public_path__ + "static/media/visa-master.4385fcda.svg";